import { cn } from "@/lib/utils";
import { TrendingUp, TrendingDown } from "lucide-react";

export function StatCard({ label, value, icon: Icon, delta, accent = "emerald", sub, testid }) {
  const accents = {
    emerald: "bg-pawkt-primary-soft text-pawkt-primary-deep",
    indigo: "bg-[#EAEFFB] text-[#4C68B5]",
    amber: "bg-pawkt-butter text-pawkt-secondary-deep",
    sky: "bg-pawkt-sky text-pawkt-primary-deep",
    rose: "bg-pawkt-coral text-pawkt-emergency",
    slate: "bg-pawkt-elevated text-pawkt-text-secondary",
    mint: "bg-pawkt-mint text-pawkt-success-deep",
  };
  return (
    <div
      data-testid={testid}
      className="rounded-xl border border-pawkt-border bg-white p-5 shadow-card transition-all duration-200 hover:-translate-y-[2px] hover:shadow-cardLift"
    >
      <div className="flex items-start justify-between">
        <p className="text-[11px] font-bold uppercase tracking-wide text-pawkt-text-secondary">{label}</p>
        {Icon && (
          <div className={cn("h-9 w-9 rounded-xl flex items-center justify-center", accents[accent])}>
            <Icon className="h-[18px] w-[18px]" />
          </div>
        )}
      </div>
      <div className="mt-3 font-display text-2xl font-extrabold tracking-tight text-pawkt-text tabular">{value}</div>
      <div className="mt-1 flex items-center gap-2">
        {delta !== undefined && delta !== null && (
          <span className={cn("inline-flex items-center gap-0.5 text-xs font-bold",
            delta >= 0 ? "text-pawkt-success-deep" : "text-pawkt-emergency")}>
            {delta >= 0 ? <TrendingUp className="h-3 w-3" /> : <TrendingDown className="h-3 w-3" />}
            {Math.abs(delta)}%
          </span>
        )}
        {sub && <span className="text-xs text-pawkt-text-disabled">{sub}</span>}
      </div>
    </div>
  );
}
